/*!

=========================================================
* Argon Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

class AuxFooter extends React.Component {
  render() {
    return (
      <>
        {/* <div className="header bg-danger pt-2 pb-7">
          <Container></Container> */}
        <footer className="py-5 bg-default" id="footer-main">
          <Container>
            <Row className="align-items-center justify-content-xl-between">
              <Col xl="12">
                <div className="copyright text-center text-muted">
                  © {new Date().getFullYear()}{" "}
                  <a
                    className="font-weight-bold ml-1 text-danger"
                    rel="noopener noreferrer"
                    href="https://www.goliveconsultoria.com.br"
                    target="_blank"
                  >
                    Golive Consultoria
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </footer>
      </>
    );
  }
}

export default AuxFooter;
